export const English = {
    en: {
        "O2Input":"O₂ Input",
        "OximeterState":"Oximeter state",
        "DeviceOnOff":"Device on/off",
        "Oximeter":"Oximeter",
        "SpO2":"SpO₂",
        "O2":"O₂",
        "Pulse":"Pulse",
        "b/min":"b/min",
        "l/min":"l/min",
        "Trends":"Trends",
        "Patient":"Patient",
        "NewPatient":"New patient",
        "PatientID":"Patient ID: ",
        "Admin":"Admin",
        "Back":"Back",
        "Edit":"Edit",
        "Cancel":"Cancel",
        "Clear":"Clear",
        "Accept":"Accept",
        "Select":"Select",
        "Undo":"Undo",
        "Value":"Value",
        "Previous":"Previous",
        "Save":"Save",
        "Next":"Next",
        "PauseScreenType":"Pause screen type",
        "GoToPauseScreenAfter":"Go to pause screen after",
        "Trend info":"Trend Info",
        "BatteryState":"Battery state",
        "Battery":"Battery",
        "BatteryLow":"Battery low",
        "BatteryCritical":"Battery critical",
        "Location":"Location",
        "FlowError":"Flow error",
        "Noflow":"No flow",
        "NotConnected":"Not connected",
        "NoSignal":"No signal",
        "ManualMode":"Manual Mode",
        "NoPatientAlarms":"No patient Alarms",
        "PowerDown":"Power Down",
        "NewPatientID":"New patient ID",
        "SetPatientName":"Set patient name",
        "NoSignalDelay":"No Signal Delay",
        "SignalAlarmDelay":"Signal alarm delay",
        "Profile":"Profile",
        "ManageProfiles":"Manage profiles",
        "ConfirmRisky":"Confirm risky profile?",
        "ActiveProfile":"Active profile: ",
        "ConfirmCritical":"Confirm critical profile?",
        "ActiveProfile":"Active Profile: ",
        "CurrentProfile":"Current profile: ",
        "CustomizeProfile":"Customize profile",
        "ViewCustomizeCurrentProfile":"View / customize current profile",
        "ChooseNewProfile":"Choose new profile",
        "ProfileChange":"Profile change",
        "DoNotTurnOfDevice":"WARNING, DO NOT TURN OFF DEVICE WHILE FORMATTING.",
        "InputUsbPin":"Input USB PIN",
        "InputAdminPin":"Input admin PIN",
        "InputCurrentPin":"Input current PIN",
        "PinAccepted":"Pin accepted, choose a new PIN",
        "ChangePin":"Change PIN",
        "RestoreDefaultPin":"Restore default PIN",
        "AdminMenuLock":"Admin menu lock",
        "Number":"Number",
        "DeviceStatus":"Device status",
        "ViewDeviceStatus":"View device status",
        "OK":"OK",
        "AcusticAlarm":"Acustic Alarm",
        "Oximeter Sensor":"Oximeter Sensor",
        "BackupCircuit":"Backup Circuit",
        "Valve":"Valve",
        "FlowMeter":"Flow Meter",
        "Memory":"Memory",
        "Battery":"Battery",
        "Submit":"Submit",
        "Year":"Year",
        "Month":"Month",
        "Day":"Day",
        "Hour":"Hour",
        "Minute":"Minute",
        "SaveAndClose":"Save and close",
        "Commit":"Commit",
        "DeleteProfile?":"Delete Profile?",
        "DiscardChanges?":"Discard changes?",
        "Main":"Main",
        "Trend":"Trend",
        "TrendInfo":"Trend Info",
        "12M":"12M",
        "1H":"1H",
        "8H":"8H",
        "24H":"24H",
        "Contact":"Contact",
        "ConfirmReset":"Confirm reset",
        "DeviceFactoryReset":"Device factory reset",
        "Confirm":"Confirm",
        "EndTest":"End Test",
        "EndTest?":"End Test?",
        "SetDateTime":"Set date / time",
        "GeneralSettings":"General settings",
        "ScreenSettings":"Screen settings",
        "ManagePinSettings":"Manage PIN settings",
        "ReduceScreenBrightnessAfter":"Reduce screen brightness after",
        "PauseScreenType":"Pause screen type",
        "ValueMinutes": "%{value} min",
        "ValueSeconds": "%{value} sec",
        "ScreenDimmingDelay":"Screen dimming delay",
        "BlindVitalValues":"Blind vital values",
        "Shown":"SHOWN",
        "Hidden":"HIDDEN",
        "SampleRate":"Sample rate",
        "SessionSampleInterval":"Session sample interval",
        "PerformWalkingTest":"Perform walking test",
        "WalkingTests":"Walking Tests",
        "6_MWT": "6 minutes",
        "ISWT": "Incremental shuttle",
        "ESWT": "Endurance shuttle",
        "WarmupTime": "Warmup time",
        "TestTime": "Test time",
        "RecoveryTime": "Recovery time",
        "BatteryMode":"Battery Mode",
        "ConnectToPower":"Connect to Power",
        "Normal":"Normal",
        "WeakSignal": "Weak signal",
        "GoToPauseScreenAfter": "Go to pause screen after",
        "ReduceScreenBrightnessAfter": "Reduce screen brightness after",
        "NoFlow": "No flow",
        "InputMasterPin": "Input Master PIN",
        "InputAdminPin": "Input Admin PIN",
        "StartNewPatient": "Start new patient?",
        "MinSpO2": "Min SpO2",
        "MaxSpO2": "Max SpO2",
        "MinO2Flow": "Min O2 Flow",
        "MaxO2Flow": "Max O2 Flow",
        "InitialO2": "Initial O2",
        "MinPulseRate": "Min Pulse Rate",
        "MaxPulseRate": "Max Pulse Rate",
        "FlowResponse": "Flow response",
        "bpm": " bpm",
        "HighSpO2": "High SpO2",
        "CriticallyLowSpO2": "Critically low SpO2",
        "VeryLowSpO2": "Very low SpO2",
        "LowSpO2": "Low SpO2",
        "LowPulse": "Low pulse",
        "CriticallyLowPulse": "Critically low pulse",
        "HighPulse": "High pulse",
        "CriticallyHighPulse": "Critically high pulse"
    }
}